module.exports = __webpack_public_path__ + "img/jpeg.84858732.svg";